import * as fromManager from '../actions/manager.action';
import {User} from '../../../users/user';
import {AppState} from '../../../store/reducers/index';


export interface ManagerState {
  users: User[];
  user?: User;
  loading: boolean;
  loaded: boolean;
  error: string;
  updated: boolean;
}

export const initialState = {
  users: null,
  loading: false,
  loaded: true,
  error: null,
  user: null,
  updated: false,
};

export function reducer(state = initialState, action: fromManager.ManagerAction): ManagerState {
  switch (action.type) {
    case fromManager.GET_ALL_MANAGERS: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromManager.GET_ALL_MANAGERS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        users: action.payload,
        error: null
      };
    }
    case fromManager.GET_ALL_MANAGERS_ERROR: {
      return {
        ...state,
        loading: false,
        loaded: true,
        users: null,
        user: null,
        error: action.payload
      };
    }
    case fromManager.GET_MANAGER: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };
    }
    case fromManager.GET_MANAGER_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        user: action.payload,
        error: null
      };
    }
    case fromManager.GET_MANAGER_ERROR: {
      return {
        ...state,
        loading: false,
        loaded: true,
        users: null,
        user: null,
        error: action.payload
      };
    }
    case fromManager.ADD_MANAGER: {
      return {
        ...state,
        user: action.payload,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromManager.ADD_MANAGER_SUCCESS: {
      return {
        ...state,
        user: action.payload,
        loading: false,
        loaded: true,
        error: null
      };
    }
    case fromManager.ADD_MANAGER_ERROR: {
      return {
        ...state,
        error: action.payload,
        loading: false,
        loaded: true,
      };
    }
    case fromManager.UPDATE_MANAGER_SUCCESS: {
      if (state.users) {
        state.users.filter((user, index) => {
          if (user.id === action.payload.id) {
            state.users[index] = action.payload;
          }
        });
      }
      return {
        ...state,
        user: action.payload,
        loading: true,
        loaded: false,
        error: null,
        updated: true
      };
    }
    case fromManager.UPDATE_MANAGER: {
      return {
        ...state,
        user: action.payload,
        loading: false,
        loaded: true,
        error: null,
        updated: false
      };
    }
    case fromManager.UPDATE_MANAGER_ERROR: {
      return {
        ...state,
        error: action.payload,
        loading: false,
        loaded: true,
        updated: true
      };
    }
  }
  return state;
}




// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/managers/store/reducers/manager.reducer.ts